import React, {Component} from 'react';
const { Link } = require('react-router');
import ProfileLink from 'components/ProfileLink'

import '../../sass/membersitem.scss';

import {t, nt} from 'l10n';
import {getGenderText, getAgeText} from 'utils/user';

class ProfilesItem extends Component
{
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    render()
    {
        let {profile} = this.props;

        let classStatus = "status";

        if(profile.online) {
            classStatus = "status active";
        }

        return (
            <div>
                <div className="item-member-list-members">
                    <div className="img">
                        <ProfileLink user={profile} className="data-location">
                            <div>
                                {profile.country && <div>{t('Country:')} {profile.country}</div>}
                                {profile.region && <div>{t('Region:')} {profile.region}</div>}
                            </div>
                        </ProfileLink>
                        <img src={profile.avatar_url} alt="name" />
                    </div>
                    <div className="text">
                        <p className="name"><ProfileLink user={profile}/> <span className={classStatus}></span></p>
                        <p>{getGenderText(profile)} <span className="icon"></span> {getAgeText(profile)}</p>
                    </div>
                </div>
            </div>
        )
    }
}

export default ProfilesItem;




// WEBPACK FOOTER //
// ./src/components/profiles/ProfilesItem.js